import { BRANDS } from "@/config/site";

const Leaf = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" className="shrink-0">
    <path d="M12 2c3 4 3 9 0 13-3-4-3-9 0-13Z" fill="var(--sky)" />
    <path d="M13 16c2.5-4 6-6 10-6-2 4-5.5 6-10 6Z" fill="var(--rose)" />
  </svg>
);

export const Marquee = ({ dark = false }) => {
  const items = [...BRANDS, ...BRANDS];
  return (
    <div className={`relative overflow-hidden border-y py-7 ${dark ? "border-white/15" : "hairline"}`} data-testid="brand-marquee" aria-label="Our brands">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {items.map((b, i) => (
          <div key={i} className="flex items-center gap-10" aria-hidden={i >= BRANDS.length}>
            <span className={`font-display whitespace-nowrap text-4xl md:text-6xl font-light tracking-tight ${i % 2 ? "italic" : ""}`}>{b.name}</span>
            <Leaf />
          </div>
        ))}
      </div>
    </div>
  );
};
